import "core-js/modules/es.array.find-index.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "bei-exercise"
};
var _hoisted_2 = {
  class: "bei-exercise-tab"
};
var _hoisted_3 = {
  class: "bei-exercise-content"
};
import { computed, ref } from 'vue';
import SubTab from '../../Components/SubTab.vue';
import Exercises from './Exercises.vue';
import Paper from './Paper.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var tabs = [{
      name: '习题设计',
      value: 1,
      component: Exercises,
      exist: true
    }, {
      name: '习练设计',
      value: 2,
      component: Paper,
      exist: true
    }];
    var defaultIndex = ref(1);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(SubTab, {
        tabs: tabs,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["default-index"])]), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value)))])]);
    };
  }
};